import {initPromoArticlelist} from './init';
import {Logger} from "./logger";
import {otto} from "@otto-ec/global-resources/nexus";

otto.ft3.promo.articlelist.assignNamespace({
    init: () => {
        Logger.group("[FT3 promo articlelist]");
        Logger.count("Articlelist Invocation");
        initPromoArticlelist();
        Logger.groupEnd();
    }
});